export const AVAILABLE_CONFIGURATIONS = {
    DRIVER: 'driver',
    VEHICLE: 'vehicle',
    VEHICLE_AND_DRIVER: 'vehicle-and-driver',
    DRIVER_AND_VEHICLE: 'driver-and-vehicle',
};
